import React from "react";

import { CheckCircle2, Clock3, Circle } from "lucide-react";

interface FieldStatusIconProps {
  status: string;
}

export const FieldStatusIcon: React.FC<FieldStatusIconProps> = ({ status }) => {
  if (status === "complete") {
    return <CheckCircle2 size={16} className="text-green-500" />;
  }
  if (status === "partial") {
    return <Clock3 size={16} className="text-amber-400" />;
  }
  return <Circle size={16} className="text-white/30" />;
};
